<app-page-title icon="fa-pie-chart" title="Relatórios (beta)"></app-page-title>

<section class="reports">
  <div class="card mb-2" *ngIf="user.analytics_sync">
    <a href="/#/analytics/campaigns" title="Relatório de cliques em links" class="title">Relatório de cliques em links</a>
    <p class="mb-0 small">Veja os cliques recebidos através das campanhas. Visualize a quantidade de envios, os cliques e o CTR por campanha e por sequência de mensagem enviada.</p>
  </div>

  <div class="card mb-2" *ngIf="user.analytics_sales_sync && (isAdmin || user.show_sales_report)">
    <a href="/#/analytics/sales">Relatório analítico de vendas</a>
    <p>Veja a performance das conversões através de UTMs por período e também ações sem UTM source que foram impusionadas pelo envio de SMS.</p>
  </div>

  <div class="card mb-2" *ngIf="user.funnel_report_enabled && (isAdmin || user.show_funnel_report)">
    <a href="/#/analytics/funnel-performance">Performance por Funil</a>
    <p>Veja o custo SMS versus o volume de vendas por funil. ROI por campanha e por mensagem com atribuição de conversão.</p>
  </div>
</section>
